<template>
    <SectionWrapper>
        <template #title>
            <div class="font-normal pb-2 text-sm" v-if="settings.is_sourcing_mode">
                Pick Up<span class="sr-only">:</span> <span class="font-normal ml-1 text-gray text-base at1024:ml-0">1 of 1</span>
            </div>
            <span class="at1024:flex at1024:flex-col at1024:items-start" v-else">
                Pick Up<span class="sr-only">:</span> <span class="font-normal ml-1 text-gray text-base at1024:ml-0">1 of 1</span>
            </span>
        </template>
        <template #default>
            <ul
                :class="{
                    'space-y-2 at1024:space-y-4': !settings.is_sourcing_mode,
                    'space-y-4 mb-6': settings.is_sourcing_mode,
                }"
            >
                <li
                    :class="{
                        'gap-3 p-6 border border-keyline-primary flex flex-col rounded-md bg-gray-tier-4-light': settings.is_sourcing_mode,
                    }"
                >
                    <PickUpCard :order="order" :cards="cards" :is-large="true" />
                </li>
            </ul>
        </template>
    </SectionWrapper>
</template>

<script setup>
import {PickUpCard, SectionWrapper} from "@/Themes/Marketing";
import {useUser} from "@/Composables";

const props = defineProps(['order', 'cards']);
const { settings } = useUser();
</script>
